import type { AggStatus, InstitutionLoginProps } from './institutionLoginsTypes';

export function isErrorType(aggStatusString?: AggStatus | null) {
  const acceptable = [
    'NEW',
    'OK',
    'MFA_CHALLENGE_READY_FOR_USER',
    'DISCOVERED_ACCOUNTS_READY_FOR_USER',
    'NO_ACCOUNTS_REFRESHED',
  ];
  return aggStatusString && !acceptable.includes(aggStatusString);
}

export const isInstitutionLoginConnected = (institutionLogin: InstitutionLoginProps) => institutionLogin.isConnected;
